import Service from "../Service";
import AccountService from "./AccountService";
import moment from "moment-timezone";
import DateHelper from "../../components/DateHelper";
import obj from "lodash/object";


const api = new Service(true, 'pendingAppointments');
const account = new AccountService();
const d = new Date();


let pending = [];
let tid = null;
let enablePolling = true;
let pollingInterval = 5000; //5sec
const listeners = {};
let busy = false;

const triggerListeners = () => {
	for(let p in listeners) {
		const func = listeners[p];
		if(typeof(func) === 'function'){
			func(pending);
		}
	}
}

const localTimezone = moment.tz.guess();

//console.log('TimeZone:', localTimezone);


/**
 * Converts UTC Date string to current timezone moment
 * @param dateString
 * @returns moment
 */
const convertToLocalTZ = (dateString) => {
	return moment.tz(dateString, 'UTC').tz(localTimezone);
}

const convertExtAppDates = (apps) => {
	return apps.map((app) => {
		app.startDate = DateHelper.DateToServerString(convertToLocalTZ(app.startDate));
		app.endDate = DateHelper.DateToServerString(convertToLocalTZ(app.endDate));
		return app;
	})
}

const ExtToInAppMap = {
	'biopedClinicId' : 'clinicId',
	'biopedUserId' : 'userId',
	'externalAppointmentId': 'externalAppointmentId',
	'startDate': 'start',
	'endDate': 'end',
	'client.clientId': 'clientId'
}

/**
 * Tries to convert External Appointment data to internal appointment data
 * @param app - External Appointment Object
 * @returns {*} - externally formatted app data object
 * @constructor
 */
export const ExtAppToIntApp = (app) => {
	const o = {};
	//console.log('ExtAppToIntApp:', app);
	for(let p in ExtToInAppMap){
		const val = obj.get(app, p);
		const prop = ExtToInAppMap[p];
		o[prop] = val;
	}

	const rs = app.requestedService || '';

	if(rs.charAt(rs.length - 1) === '*'){
		o.clientHasRx = true;
	}

	//console.log('Converted App:', o);

	return Object.assign(o, app);
}

export default class ExtAppService{

	static get Pending(){
		return pending;
	}

	static AddListener(id, func){
		if(typeof(func) === 'function'){
			listeners[id] = func;
			func(pending);
		}
	}

	static RemoveListener(id){
		delete listeners[id];
	}

	static StartPolling(){
		enablePolling = true;
		this.UpdatePending();
	}

	static StopPolling(){
		enablePolling = false;
		clearTimeout(tid);
		tid = null;
	}

	static UpdatePending(){
		if(busy)return;
		if(tid)clearTimeout(tid);
		busy = true;
		this.GetPending().then((data) => {
			pending = data;
			triggerListeners();
			busy = false;
			if(enablePolling) {
				tid = setTimeout(() => {
					this.UpdatePending();
				}, pollingInterval)
			}
		}).catch((e) => {
			busy = false;
		})
	}

	static GetPending(){
		return api.request(`ExternalAppointments/${account.clinicId}`, {noCache: true}).then((apps) => {
			return convertExtAppDates(apps);
		});
	}
	static UpdateAppointment(app) {
		return api.request(`ExternalAppointments/${app.externalAppointmentId}`, {put: app, noCache: true})
	}

	static LinkPatient(extAppData, clientId){
		return api.request(`ExternalAppointmentClientMap`, {post: {clientId, clinicId: extAppData.biopedClinicId,  ...extAppData}, noCache: true});
	}

	/**
	 * Search linked clients
	 * @param query Search query
	 * @param query.clientId Search via client Id
	 * @param query.emailAddress Search via email address
	 * @returns {Promise | Promise<unknown>}
	 * @constructor
	 */
	static SearchLinkedPatient(query) {
		return api.request('ExternalAppointmentClientMap', {get: query, noCache: true})
	}

	static DeletePatientLink(extAppData) {
		return api.request(`ExternalAppointmentClientMap`, {delete: extAppData, noCache: true});
	}


}



// WEBPACK FOOTER //
// ./src/api/services/ExtAppService.js